import script from "./PlansTab.vue?vue&type=script&setup=true&lang=js"
export * from "./PlansTab.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__